import React from 'react';
import './style.scss';
import { DefaultIcon, Delete as DeleteIcon, Pencil as PencilIcon } from '../../../atoms/icons';

interface Props {
    id: string | undefined;
    name: string;
    email: string;
    deleteIcon?: React.ReactElement<DefaultIcon> | undefined;
    editIcon?: React.ReactElement<DefaultIcon> | undefined;
    commission: number;
}

const Partner: React.FC<Props> = (props) => {
  const {
    id, name, email, commission,
    deleteIcon = <DeleteIcon width={18} color="black" />,
    editIcon = <PencilIcon width={20} color="black" />,
  } = props;
  const first = name.slice(0, 1);
  return (
    <div className="card-partner-container" id={id}>
      <div className="partner-container">
        <div className="d-flex justify-content-between">
          <div className="d-flex justify-content-start">
            <div className="partner-profil">
              <div className="icon-name">
                {first}
              </div>
            </div>
            <div className="partner-header">
              <div className="partner-name">
                {name}
              </div>
              <div className="partner-email">
                {email}
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-end icon">
            <div className={deleteIcon ? 'me-2' : 'd-none'}>{deleteIcon}</div>
            <div style={editIcon ? { marginTop: '1px' } : {}} className={editIcon ? '' : 'd-none'}>{editIcon}</div>
          </div>
        </div>

        <div className="partner-commission">
          <div className="label">
            COMMISSION:
          </div>
          <div className="percentage">{`Percentage ${commission}%`}</div>
        </div>
      </div>
    </div>
  );
};

export default Partner;
